















import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from '@/components/Button.vue';

@Component({
  components: { Button },
})
export default class Overlay extends Vue {
  @Prop({ required: false, type: Boolean })
  public isOpen: Boolean = false;

  openState: Boolean = false;

  @Emit('open')
  public open() {
    this.openState = true;
    document.body.style.overflow = 'hidden';
  }
  @Emit('close')
  public close() {
    this.openState = false;
    document.body.style.overflow = '';
  }

  @Watch('isOpen', { immediate: true })
  onIsOpenChange(val: Boolean) {
    if (val) {
      this.open();
    } else {
      this.close();
    }
  }
}
